var map = {
	"./logo-keno.png": 603,
	"./logo-lotto535.png": 604,
	"./logo-max3d.png": 605,
	"./logo-max3dpro.png": 606,
	"./logo-mega.png": 607,
	"./logo-power.png": 608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;